import { i18n } from "@/locale";

const {
    global: { t },
} = i18n;

import layout from "@/layouts/dashboard";

export default [
    {
        path: "/dashboard/assets",
        name: "dashboard-assets",
        component: layout,
        redirect: {
            name: "dashboard-assets",
        },
        children: [
            // 全部权益
            {
                path: "benefits",
                name: "dashboard-assets-benefits",
                component: () => import("@/views/assets/benefits.vue"),
                meta: {
                    title: t("common.routes.benefitsTitle"),
                    desc: t("common.routes.benefitsDesc"),
                },
            },
            {
                path: "history/:slug",
                name: "dashboard-assets-benefits-history",
                component: () => import("@/views/assets/history.vue"),
                meta: {
                    title: t("common.routes.benefitsTitle"),
                    desc: t("common.routes.benefitsDesc"),
                },
            },
            // 兑换码
            {
                path: "code",
                name: "dashboard-assets-code",
                component: () => import("@/views/assets/code.vue"),
                meta: {
                    title: t("common.routes.codeTitle"),
                    desc: t("common.routes.codeDesc"),
                },
            },
            {
                path: "purchase/:slug",
                name: "dashboard-assets-purchase",
                component: () => import("@/views/assets/purchase.vue"),
                meta: {
                    title: t("common.routes.purchaseTitle"),
                    desc: t("common.routes.purchaseDesc"),
                },
            },
        ],
    },
];
